<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">

    <div class="spacer5"></div>
    <div class="pcontainter">
      <h2>Quickstart Guide</h2>
      <div class="spacer2"></div>

      <div>
        Welcome to XDBrain! Follow this guide to get started quickly with
        setting up your workspace, configuring authentication, and integrating
        with our Python SDK.
      </div>

      <div class="spacer5"></div>

      <h3>Create a Workspace</h3>
      <div>Start by creating your workspace:</div>
      <div>
        <ul>
          <li>Go to Workspaces.</li>
          <li>Click on create.</li>
          <li>Provide the Workspace Name and Institution Name and Id.</li>
          <li>Click Create to initialize your workspace.</li>
        </ul>
      </div>
      <div>
        A workspace is the foundation for organizing your memory, mind maps,
        reminders, and more.
      </div>

      <div class="spacer5"></div>

      <h3>Activate Your Workspace</h3>
      <div>
        To activate your workspace, you'll need to generate and upload an ECDSA
        key pair.
      </div>
      <div>Generate ECDSA Key Pair</div>
      <div>
        <ul>
          <li>Generate an ECDSA key pair (P-256) in your browser.</li>
          <li>The private key is securely stored in the browser's CryptoDB.</li>
          <li>
            The public key is Base64-encoded (P64) and uploaded to the server.
          </li>
        </ul>
      </div>
      <div>
        We do not store your private key. Losing it means losing access to your
        data.
      </div>

      <div class="spacer5"></div>

      <h3>Handshake with Server</h3>
      <div>After uploading your public key:</div>
      <div>
        <ul>
          <li>
            A handshake request is initiated by signing a test payload using
            your private key.
          </li>
          <li>
            The server verifies the signature using the uploaded public key.
          </li>
          <li>Once verified, your workspace is activated.</li>
        </ul>
      </div>

      <div class="spacer5"></div>

      <h3>Submit OpenAI API Key</h3>
      <div>To enable AI-based memory operations:</div>
      <div>
        <ul>
          <li>Navigate to the Workspace List page.</li>
          <li>Click on Submit OpenAI Key.</li>
          <li>Enter your personal OpenAI API Key.</li>
        </ul>
      </div>
      <div>
        We encourage you to use your own OpenAI key for full control and
        privacy.
      </div>

      <div class="spacer5"></div>

      <h3>Install Python SDK</h3>
      <div>
        Our official Python SDK makes it easy to integrate XDBrain into your
        applications with powerful AI agent capabilities.
      </div>

      <div class="spacer2"></div>

      <div class="sdk-info-card">
        <div class="sdk-header">
          <strong>Python SDK & AI Agents</strong>
        </div>
        <div class="spacer2"></div>
        <div>
          Get started with our comprehensive Python SDK that includes LangChain
          integration and pre-built AI agent templates for rapid development.
        </div>
        <div class="spacer2"></div>
        <div class="sdk-actions">
          <a
            href="https://github.com/netsys-usa/netxd_xdb_ai_agents/blob/master/ai_agent_langchain/python/README.md"
            target="_blank"
            class="sdk-link"
          >
            <i class="fa fa-book" style="margin-right: 6px"></i>
            View Documentation & Examples
          </a>
          <span class="external-link-indicator">
            <i
              class="fa fa-external-link"
              style="font-size: 12px; color: #666"
            ></i>
          </span>
        </div>
        <div class="spacer1"></div>
        <div class="sdk-features">
          <small>
            <i
              class="fa fa-check"
              style="color: #28a745; margin-right: 4px"
            ></i>
            Installation instructions &nbsp;&nbsp;
            <i
              class="fa fa-check"
              style="color: #28a745; margin-right: 4px"
            ></i>
            Code examples &nbsp;&nbsp;
            <i
              class="fa fa-check"
              style="color: #28a745; margin-right: 4px"
            ></i>
            LangChain integration
          </small>
        </div>
      </div>

      <div class="spacer5"></div>

      <h3>You're Ready!</h3>
      <div>
        You've successfully set up your XDBrain workspace and are ready to
        integrate with our APIs. Jump into the docs or start coding right away.
      </div>

      <div class="spacer5"></div>
    </div>


    </div>
  </div>
</div>
